<p-card>
  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center gap-15">
        <h3 *ngIf="title">{{ title }}</h3>
        <app-icon-feather
          *ngIf="tooltip"
          icon="help-circle"
          tooltipPosition="top"
          [pTooltip]="tooltip"
          [strokeWidth]="2"
          stroke="#528BB0"
        ></app-icon-feather>
      </div>
    </div>
  </div>
  <div class="mt-4 pt-3">
    <app-form-constructor
      class="form"
      [formConfig]="formConfig"
      (changeFormEvent)="form = $event"
    ></app-form-constructor>

    <div class="button-wrapper mt-5 pt-4 gap-20 d-flex justify-content-end">
      <button pButton
              class="p-button-outlined"
              (click)="cancelEvent.emit()"
              label="CANCEL"
      ></button>

      <button pButton
              label="SAVE"
              (click)="submit()"
              [disabled]="!form || !form.valid"
      ></button>
    </div>
  </div>
</p-card>
